import * as React from 'react';
import styled, { keyframes } from 'styled-components';

const DancingDots = () => {
    return (
        <StyledDancingDots>
            <StyledOne />
            <StyledTwo />
            <StyledThree />
        </StyledDancingDots>
    );
};

export default DancingDots;

const Bouncing = keyframes`
    0% {
        top: 0;
    }

    55% {
        top: 0;
    }

    60% {
        top: -10px;
    }

    80% {
        top: 3px;
    }

    90% {
        top: -2px;
    }

    95% {
        top: 1px;
    }

    100% {
        top: 0;
    }
`;

const StyledDancingDots = styled.div`
    display: inline-block;

    > span {
        animation: ${Bouncing} 2s linear infinite;
        padding: 0;
        position: relative;
        width: 4px;
        display: inline-block;

        &::after {
            content: '.';
        }
    }
`;

const StyledOne = styled.span`
    && {
        animation-delay: 0ms;
    }
`;
const StyledTwo = styled.span`
    && {
        animation-delay: 100ms;
    }
`;
const StyledThree = styled.span`
    && {
        animation-delay: 300ms;
    }
`;
